import React from "react";
import SEO from "../SEO/SEO.jsx"

const Services = () => {
  return (
    <div className="middle">
      {/* Adding SEO Meta tags */}
      <SEO
        title={"Car Cleaning Services in Jaipur | Interior & Exterior Wash – WashWoosh"}
        description={
          "Explore car cleaning services in Jaipur by WashWoosh – exterior wash, full interior cleaning & waterless eco-wash. Plans start at ₹249. Book now!"
        }
        canonical={"https://washwoosh.com/services"}
      />

      <div className="our-services-men what-we-offer">
        <div className="container">
          <div className="heading-men">
            <h1>Our Car Cleaning Services in Jaipur</h1>
            <p className="welcome-text">
            </p>
            <p>WashWoosh offers a variety of premium <strong className="highlight">car cleaning services in Jaipur</strong> designed to suit
              different customer needs. Our services include:</p>
          </div>
          <div className="row mt-4 align-items-center">
            <div
              className="col-lg-6 col-md-6"
              data-aos="fade-down"
              data-aos-duration={2000}
            >
              <div className="why-chooseus-one-photo">
                <img
                  className="img-fluid"
                  src="images/cleaning-service-page.png"
                  alt="Why Choose Us Photo"
                />
              </div>
            </div>
            <div
              className="col-lg-6 col-md-6"
              data-aos="zoom-in-up"
              data-aos-duration={2000}
            >
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="why-chooseus-one">

                    <h2>
                      Basic Exterior Wash:
                    </h2>
                    <p>
                      A quick and efficient wash that removes dirt and dust from the
                      car’s surface, leaving it clean and fresh.
                    </p>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12">
                  <div className="why-chooseus-one mt-4 mb-4">

                    <h2>Complete Exterior & Interior Cleaning:</h2>
                    <p>
                      A thorough cleaning service that includes
                      interior vacuuming, dashboard polishing, and deep cleaning of all exterior surfaces.
                    </p>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12">
                  <div className="why-chooseus-one mb-4">

                    <h2>Eco-Friendly Waterless Car Wash:</h2>
                    <p>
                      An eco-friendly solution that uses advanced cleaning agents to
                      achieve a spotless shine without excessive water usage.
                    </p>
                  </div>
                </div>

                <div className="col-lg-12 col-md-12">
                  <div className="why-chooseus-one">

                    <h2>Flexible Subscription Plans:</h2>
                    <ul><li>
                      <h2>Daily & Monthly Plans:</h2>
                      <p>
                        Customized packages for regular car maintenance at
                        affordable rates, perfect for busy car owners.
                      </p></li>
                      <li>
                        <h2>Quarterly Plan:</h2>
                        <p>
                          A user-favorite option that offers consistent car cleaning
                          services every three months, combining convenience and cost-effectiveness. Plus,
                          enjoy exclusive perks with each monthly service, including a car freshener and a
                          tissue paper box—because a clean car should also smell fresh and feel
                          comfortable.
                        </p></li></ul>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="heading-men pt-5 p-0">
            <p>All services are performed by our team of  <strong className="highlight">trained car cleaners in Jaipur</strong>, ensuring that your
              vehicle receives expert care right at your doorstep.
            </p>
          </div>
        </div>
      </div>
      <div className="At-fingertips-men">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-12 col-md-12"
              data-aos="zoom-in"
              data-aos-duration={2000}
            >
              <div className="At-fingertips-left">
                <div className="heading-men p-0">
                  <img
                    className="app-icon-photo"
                    src="images/app-icon.png"
                    alt="App Icon"
                  />
                  <h2>At your doorstep, at your fingertips</h2>
                  <p className="pt-2">
                    Experience the most convenient, professional, and
                    eco-friendly car wash solution—just a tap away!
                  </p>
                  <div className="all-btn">
                    <div className="row mt-4 justify-content-center">
                      <div className="col-lg-2 play">
                        <div className="btn1 btn2">
                          <a href="https://play.google.com/store/apps/details?id=com.washwoosh.userapp&pcampaignid=web_share" aria-label="Download WashWoosh App From Paly Store For Android Users">
                            <img
                              className="img-fluid"
                              src="images/d-app1.png"
                              alt="Play Store Icon"
                            />
                          </a>
                        </div>

                        <div className="btn1 btn2">
                          <a href="https://apps.apple.com/in/app/washwoosh-car-care-app/id6738276020" aria-label="Download WashWoosh App From App Store For ios Users">
                            <img
                              className="img-fluid"
                              src="images/d-app2.png"
                              alt="App Store Icon"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
